exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".both-label[data-v-13e9fede]{line-height:20px;color:rgba(0,0,0,.85)}.top-nav[data-v-13e9fede]{background:#304156;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding-left:30px}.top-nav .tab-box[data-v-13e9fede]{width:150px;background:#768089;border-radius:10px 10px 0px 0px;text-align:center;margin-top:24px;padding:18px;font-size:14px;color:#fff;cursor:pointer;margin-right:10px}.top-nav .tab-box-active[data-v-13e9fede]{background:#fff;color:#282828}", ""]);

// exports
